import { render, staticRenderFns } from "./MenuItemsForm.vue?vue&type=template&id=0aa3768d&scoped=true"
import script from "./MenuItemsForm.vue?vue&type=script&lang=js"
export * from "./MenuItemsForm.vue?vue&type=script&lang=js"
import style0 from "./MenuItemsForm.vue?vue&type=style&index=0&id=0aa3768d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3768d",
  null
  
)

export default component.exports